import React from "react";
import {
    Card,
    CardContent
} from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Search } from "lucide-react";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
    return (
        <Card>
            <CardContent className="p-4">
                <div className="relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
                    <Input
                        placeholder="Search blog posts..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="pl-10"
                    />
                </div>
            </CardContent>
        </Card>
    );
}

export default SearchBar;